import styled from '@/styles';

export const Backdrop = styled('div', {
  position: 'fixed',
  inset: 0,
  background: 'rgba(28, 28, 28, 0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  padding: 24,
});

export const ModalCard = styled('div', {
  background: '#fff',
  borderRadius: 12,
  padding: 24,
  width: '100%',
  maxWidth: 520,
  maxHeight: 'calc(100vh - 48px)',
  overflowY: 'auto',
  boxShadow: '0 12px 32px rgba(0,0,0,0.18)',
  fontFamily: "'Manrope', sans-serif",
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

export const ModalHeader = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const ModalTitle = styled('h4', {
  margin: 0,
  fontSize: 18,
  fontWeight: 700,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
});

export const CloseButton = styled('button', {
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: 4,
  lineHeight: 0,
  color: '#5B5B5B',
  '&:hover': { color: '#1C1C1C' },
});

export const FieldStack = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

export const FieldLabel = styled('label', {
  fontSize: 13,
  fontWeight: 600,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
});

export const ModalInput = styled('input', {
  width: '100%',
  height: 36,
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: '0 12px',
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  background: '#fff',
  outline: 'none',
  boxSizing: 'border-box',
  '&::placeholder': { color: '#979797' },
  '&:focus': { borderColor: '#44A735' },
});

export const ModalSelect = styled('select', {
  width: '100%',
  height: 36,
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: '0 8px',
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  background: '#fff',
  outline: 'none',
  boxSizing: 'border-box',
  '&:focus': { borderColor: '#44A735' },
});

export const ModalTextArea = styled('textarea', {
  width: '100%',
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: '10px 12px',
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  background: '#fff',
  outline: 'none',
  boxSizing: 'border-box',
  resize: 'vertical',
  minHeight: 80,
  '&::placeholder': { color: '#979797' },
  '&:focus': { borderColor: '#44A735' },
});

export const AddressRow = styled('div', {
  display: 'grid',
  gridTemplateColumns: '2fr 1fr 1fr',
  gap: 12,
});

export const AutocompleteWrap = styled('div', {
  position: 'relative',
});

export const SuggestionPanel = styled('div', {
  position: 'absolute',
  top: 'calc(100% + 4px)',
  left: 0,
  right: 0,
  background: '#fff',
  border: '1px solid #DADADA',
  borderRadius: 8,
  boxShadow: '0 4px 12px rgba(0,0,0,0.10)',
  zIndex: 20,
  maxHeight: 220,
  overflowY: 'auto',
});

export const SuggestionRow = styled('div', {
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  '&:hover': { background: '#F4FBF2' },
  variants: {
    highlighted: {
      true: { background: '#F4FBF2' },
    },
  },
});

export const SuggestionMain = styled('span', {
  fontWeight: 600,
});

export const SuggestionSecondary = styled('span', {
  fontSize: 12,
  color: '#5B5B5B',
});

export const Footer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 12,
  marginTop: 8,
});

export const CancelLink = styled('button', {
  background: 'transparent',
  border: 'none',
  color: '#5B5B5B',
  fontSize: 14,
  fontWeight: 600,
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  padding: '8px 12px',
  '&:disabled': { opacity: 0.5, cursor: 'not-allowed' },
});

export const PrimaryButton = styled('button', {
  background: '#44A735',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  padding: '8px 18px',
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  '&:hover': { background: '#2E8722' },
  '&:disabled': { opacity: 0.5, cursor: 'not-allowed', background: '#9DC97A' },
});

export const ErrorLine = styled('p', {
  margin: 0,
  color: '#C0392B',
  fontSize: 12,
});

export const BrowseLink = styled('button', {
  background: 'transparent',
  border: 'none',
  color: '#2E8722',
  fontSize: 13,
  fontWeight: 600,
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  padding: 0,
  alignSelf: 'flex-start',
});
